var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandValuePlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 121,
    height: 121,
    viewBox: "0 0 121 121",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(0 -0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#096DD9",
    d: "M0 .5h121v121H0z"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "NouvelR",
    fontSize: 23.081,
    fontWeight: "bold",
    letterSpacing: -0.385,
    fill: "#FFF",
    transform: "translate(0 .5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 16,
    y: 68.202
  }, "VALUE+")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandValuePlus);
export default __webpack_public_path__ + "static/media/brand_value_plus.5ffbb909dd514bc8809084d74b772136.svg";
export { ForwardRef as ReactComponent };